module.exports = "/images/softneta_logo.svg?bb9fc3a34c3ad64faf98f9dca359c32a";